import { render } from "./TermsOfUse.vue?vue&type=template&id=6c907116&scoped=true"
import script from "./TermsOfUse.vue?vue&type=script&lang=js"
export * from "./TermsOfUse.vue?vue&type=script&lang=js"

import "./TermsOfUse.vue?vue&type=style&index=0&id=6c907116&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c907116"]])

export default __exports__